import { handleActions } from "redux-actions";

import {
    setQuotaManagerDialog,
    mergeQuotaManagerDialog,
    clearQuotaLimits,
    getQuotaLimits,
    getQuotaLimitsSuccess,
    getQuotaLimitsError,
    setLimitDialog,
    mergeLimitDialog,
} from "modules/QuotaManager/services/QuotaLimits/actions";

const initialState = {
    isLoading: false,
    count: 0,
    quotaLimits: [],
    createDialog: {
        initialData: null,
        isOpen: false,
        isLoading: false
    },
    limitDialog: {
        quotaLimit: null,
        isOpen: false,
        isLoading: false,
        initialValues: {}
    },
};

export const quotaLimitsReducer = handleActions(
    {
        [clearQuotaLimits]: () => ({ ...initialState }),

        [getQuotaLimits]: (state) => ({
            ...state,
            quotaLimits: [],
            count: 0,
            isLoading: true
        }),
        [getQuotaLimitsSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getQuotaLimitsError]: (state) => ({
            ...state,
            isLoading: false
        }),
        [setQuotaManagerDialog]: (state, { payload }) => ({
            ...state,
            createDialog: {
                ...initialState.createDialog,
                ...payload
            }
        }),
        [mergeQuotaManagerDialog]: (state, { payload }) => ({
            ...state,
            createDialog: {
                ...state.createDialog,
                ...payload
            }
        }),
        [setLimitDialog]: (state, { payload }) => ({
            ...state,
            limitDialog: {
                ...initialState.limitDialog,
                ...payload
            }
        }),
        [mergeLimitDialog]: (state, { payload }) => ({
            ...state,
            limitDialog: {
                ...state.limitDialog,
                ...payload
            }
        }),
    },
    initialState
);
